export const product = {
  data(){
    return {

    }
  },
  computed: {
    /*getDiscount(){
      let brandPrice = this.item.seria.brand.price;
      let seriaPrice = this.item.seria.price;
      if (brandPrice == 0) return 0;
      //let discount = brandPrice / seriaPrice;
      let discount = Math.round((brandPrice - seriaPrice) * (100/brandPrice));
      return discount;
    },*/
  },
  methods: {
    checkPayment(){},

    retColor(col, data){
      if(col.color){
        return col.color[data];
      } else {
        return 'gray'
      }
    },
    checkColor() {
      if (this.item.oprava_colors[this.currentColor] && this.item.oprava_colors[this.currentColor].color) {
        return true;
      } else {
        return false;
      }
    },
    getColorId() {
      if (this.checkColor()) {
        let col = this.item.oprava_colors[this.currentColor].color.title;
        //console.log(col);
        return col;
      }
      return '';
    },
    getFn() {
      if(this.item.oprava_colors[this.currentColor] && this.item.oprava_colors[this.currentColor].image){
        return this.item.oprava_colors[this.currentColor].image.path;
      } else {
        return '';
      }
    },
  }
};


// WEBPACK FOOTER //
// ./themes/oprava/src/js/components/mixins/product.js